/** Terms & Conditions — adapted from https://www.jonesboothlaw.com/terms-and-conditions */
export const termsAndConditionsTitle = 'Terms and Conditions';

export const termsAndConditionsBody = `
**Jones & Booth, LLC**

**Effective Date:** January 1, 2026

## Important Notice Regarding Text Messaging Data

### FREE Accident Consultation

We send confirmation and next-step information about potential compensation eligibility after people opt in via the Meta lead form. These communications are strictly transactional, which includes Account Notification and Customer Care, opt-in, and are not promotional. No third-party leads shared or purchased.

You can cancel the SMS service at any time. Simply text "STOP" to the shortcode. Upon sending "STOP," we will confirm your unsubscribe status via SMS. Following this confirmation, you will no longer receive SMS messages from us. To rejoin, sign up as you did initially, and we will resume sending SMS messages to you.

If you experience issues with the messaging program, reply with the keyword HELP for more assistance, or reach out directly to admin@jonesboothlaw.com or 470-359-9972.

Carriers are not liable for delayed or undelivered messages.

As always, message and data rates may apply for messages sent to you from us and to us from you. Message frequency varies. For questions about your text plan or data plan, contact your wireless provider.

For privacy-related inquiries, please refer to our [Privacy Policy](/privacy-policy).
`.trim();
